import { RejectType } from "@uirouter/react";
import type { UIRouterReact } from "@uirouter/react/lib/core";

import Sentry from "@similarweb/sentry-logger";

import { SwTrack } from "app/services/SwTrack";

export const routerOnError = (router: UIRouterReact) => {
    router.transitionService.onError({}, (transition) => {
        const error = transition.error();

        if (error.type === RejectType.INVALID || error.type === RejectType.ERROR) {
            const errorCode = error.detail;
            if (errorCode instanceof Error) {
                Sentry.error("error loading page:", errorCode);
            } else if (typeof errorCode === "string") {
                Sentry.errorTracker({
                    message: "error loading page:",
                    e: new Error(errorCode),
                    params: {
                        tags: {
                            toState: transition.to().name,
                            rejectType: String(error.type),
                        },
                        extra: {
                            error,
                            from: {
                                name: transition.from().$$state?.()?.name,
                                params: transition.from().$$state?.()?.params,
                                ...transition.from(),
                            },
                            to: transition.to(),
                        },
                    },
                });
            } else {
                Sentry.error("error loading page:", new Error(error.message));
            }
            // track error
            SwTrack.all.trackEvent("PageError", transition.router.urlService.path(), errorCode || "No Status");
        } else {
        }
        // Temp comment - shut down sentry performance activity
        // navigationSpan.setStatus(SpanStatus.UnknownError);
        // closeNavigationTransaction();
    });
};
